import { useMutation, useQueryClient } from '@tanstack/react-query'

import { successToast } from 'common/components/toastNotification'
import { campaignKeys } from 'features/campaigns/api/queryKeys'

import { updateProject } from '../api'
import { projectKeys } from '../api/queryKeys'

const useUpdateProjectMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(updateProject, {
    onSuccess: (data, { accountId }) => {
      if (data.state !== 'validationError') {
        queryClient.invalidateQueries(projectKeys.projects(accountId))
        queryClient.invalidateQueries(campaignKeys.projects())
        successToast('Project updated successfully')
      }
    },
  })
}

export default useUpdateProjectMutation
